import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import PictureDisplay from '../../components/Picture/Picture';
import { convertUrl } from '../../utils/url.utils';

export const Image = observer(props => {
  const imgRef = useRef();
  const { settings, setAspectRatio, orders } = props;

  const { source, altText, link = '', target = '',  hidden, srcset } = settings;

  const [ignoreHeight, setIgnoreHeight] = useState(false);

  useEffect(() => {
    if (imgRef.current) {
      imgRef.current.addEventListener('load', imgOnLoad);
    }
    return () => {
      if (imgRef.current) {
        imgRef.current.removeEventListener('load', imgOnLoad);
      }
    };
  });

  function imgOnLoad() {
    const ratio = this.naturalWidth / this.naturalHeight;

    if (ratio < 1) {
      setAspectRatio(this.naturalWidth / this.naturalHeight);
      setIgnoreHeight(true);
    }
    setTimeout(() => props.checkHeights(), 100);
  }
  if (hidden) return null;
  return (
    <div style={{ width: '100%', height: ignoreHeight ? 'unset' : '100%' }}>
      <PictureDisplay
        src={source}
        srcset={srcset}
        ref={imgRef}
        alt={altText}
        link={convertUrl(link, orders !== undefined && orders.length > 0 ? orders[0] : null)}
        target={target}
        style={{ width: '100%', height: 'auto' }}
      />
    </div>
  );
});
